
//import '../../scss/master.scss';

//import { createHtmlTagObject } from 'html-webpack-plugin';
import JQuery from 'jquery';

import fwajax from '../../lib/fwajax.js';
import contactForm from "./contact";
import '../../lib/jquery.extendable.js';
import '../../lib/jquery.nivasSelect.js';

import Swiper, { Navigation, Pagination, Scrollbar } from "swiper";

let calculatorVariables = {
	"brainstorm": {
		"id": "brainstormCalculatorVariables",
		"TP": "130",
		"minTP": "400",
		"installation": {
			"3": "4000",
			"+1": "1000",
		},
		"room": {
			"0-200": "1",
			"201-400": "1.33",
			"401-700": "1.66",
			"700+": "2",
		},
		"kTP": {
			"1": 1,
			"2": 1,
			"3": 1,
			"4": 0.9,
			"5": 0.9,
			"6": 0.8,
			"7": 0.8,
			"8": 0.7,
			"9": 0.7,
		},
}};


var calculator = function () {

	var $el = $(".calculator");
	var numOfRoom = 0;
	var numOfRoomSelector = "";
	var kRoom = 1;
	//var roomElem = document.querySelector(".selectField span").textContent;

	var tpPrice = calculatorVariables.brainstorm.TP;
	var numOfTp = 0;
	var kTp = 0 ;

	var installationPriceElem = document.querySelector("[data-price='installation']");
	var montlyPriceElem = document.querySelector("[data-price='montly']");

	if($(".calculator").length) {
		init();
	}

	function init() {

		numOfRoom =  document.querySelector(".selectField span").textContent;
		numOfTp = $(".js-calc-btns .on").length;

		calculateInstallationPrice(numOfTp);
		calculateMontlyPrice(numOfTp, numOfRoom);

		checkSelected();
		dropSelected();
	}

	function calculateInstallationPrice(numOfTp) {
		let installationPrice = 0;

		if(numOfTp <= 3 || numOfTp == 0 || numOfTp == "undefined"){
			installationPrice = 4000;
		} else {
			installationPrice = numOfTp*1000 + 1000;
		}

		installationPriceElem.innerHTML = installationPrice;
	}

	function calculateMontlyPrice(numOfTp, numOfRoom) {
		let montlyPrice = 0;

		//kTp = calculateKTp(numOfTp);
		kRoom = calculateKRoom(numOfRoom);

		if(isNaN(montlyPrice)){
			montlyPrice = 0;
		}

		for (let i = 0; i < numOfTp; i++) {
			if(numOfTp <= 3) {
				if(kRoom <= 1) {
					montlyPrice = calculatorVariables.brainstorm.minTP;
				} else {
					montlyPrice = tpPrice * calculatorVariables.brainstorm.kTP[i] * kRoom * 3;
				}
			} else {
				if (kRoom <= 1 && i == 1) {
					montlyPrice += tpPrice * calculatorVariables.brainstorm.kTP[i+1] * kRoom + 10;
				} else {
					montlyPrice += tpPrice * calculatorVariables.brainstorm.kTP[i+1] * kRoom;
				}
			}

			montlyPrice = Math.round(montlyPrice * 100) / 100;
			montlyPriceElem.innerHTML = montlyPrice;
		}
	}

	function calculateKRoom(numOfRoom) {

		let kRoomArray = calculatorVariables.brainstorm.room;
		let returnVariable;

		for (var key in kRoomArray) {

			if(key == numOfRoom) {
				returnVariable = kRoomArray[key];
			}
		}

		return returnVariable
	}

	function checkSelected() {
		let tps = $(".js-calc-btns a");
		let string = '';

		tps.each(function( index ) {
			if($(this).hasClass("on")) {
				string += (' + ' + $(this).attr("data-name"));
			}
		});

		$('.calculator__selected-features').text(string);
	}

	function dropSelected() {
		numOfRoom =  document.querySelector(".selectField span").textContent;
		numOfRoomSelector = document.querySelector(".selectField span");
		//roomsText = document.querySelector(".calculator__selected span").attr("data-name");
		//let roomsText = $(".calculator__selected span[data-roomprice]");
		let roomsText = $(".calculator__selected span").data('roomprice');
		
		let string = '';

		string += (roomsText + numOfRoom);

		$('.calculator__selected-rooms').text(string);
	}

	$(".calculator .js-calc-btns a").on('click touchstart', function(e) {
		e.preventDefault();

		$(this).toggleClass("on");

		let data = $(this).attr("data-name");
		numOfTp = $(".js-calc-btns .on").length;

		if(numOfTp >=1 ) {
			$el.find(".calculator__selected-features").show();
		} else {
			$el.find(".calculator__selected-features").hide();
		}

		calculateInstallationPrice(numOfTp);
		calculateMontlyPrice(numOfTp, numOfRoom);
		checkSelected();
	});

	$(".calculator .nvsSel").on('change rightnow',numOfRoomSelector, function() {
		var testSel = this;
		setTimeout(function(testSel){
			var roomNumber = $(".selectField span").text();
			//console.log(roomNumber);
			dropSelected();
			calculateMontlyPrice(numOfTp,numOfRoom);
		},300);
	}).triggerHandler("rightnow");;
}

var navMobile = function () {

	$(".js-nav-toggle").on('click', function(e) {
		e.preventDefault();
		var parentItem =  $(".head-nav");
		var logo = $(".brand-bs-head");

		if (parentItem.hasClass("is-open")) {
			$(this).siblings(".head-nav").removeClass("is-open");
			$(this).removeClass("is-open");
			logo.removeClass("is-open");
		} else {
			$(this).siblings(".head-nav").addClass("is-open");
			$(this).addClass("is-open");
			logo.addClass("is-open");
		}
	});
};

var faqAccordion = function () {

	$(".js-accordion-toggle").on('click', function(e) {
		e.preventDefault();

		var parentItem =  $(this).parent();
		var panelItem =  $(this).next();

		if (parentItem.hasClass("is-open")) {
			$(this).parent().removeClass("is-open");
			$(this).next().slideUp(400);
			$(this).removeClass("is-active");
		} else {
			$(".faq .faq__item").removeClass("is-open");
			$(".faq .faq__panel").slideUp(400);
			$(this).parent().addClass("is-open");
			$(this).next().slideDown(400);
			$(this).addClass("is-active");

			let item = $(this);
			isVisible(item);
		}

		function isVisible(element) {
			var elementToPosition = $(element).offset().top - 130;
			var top_of_element = $(".faq__item-label.is-active").offset().top;
			var bottom_of_element = $(".faq__item-label.is-active").offset().top + $(".faq__item-label.is-active").outerHeight();
			var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
			var top_of_screen = $(window).scrollTop();

			if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){

			} else {
				let elem = $(".faq__item-label.is-active");

				$('html, body').animate({
					scrollTop: ($(elem).offset().top)
				}, 600);
			}
		}
	});
};

var aimyAccordion = function () {

	$(".js-acc-toggle").on('click', function(e) {
		e.preventDefault();

		var parentItem =  $(this).parent();
		var panelItem =  $(this).next();

		if (parentItem.hasClass("is-open")) {
			$(this).parent().removeClass("is-open");
			$(this).next().slideUp(400);
		} else {
			$(".aimy-spot__box").removeClass("is-open");
			$(".aimy-spot__boxabstract").slideUp(400);
			$(this).parent().addClass("is-open");
			$(this).next().slideDown(400);
		}
	});
};

var contactWrap = function () {

	$(".js-form").on('click', function(e) {
		e.preventDefault();
		var selector = $(this).attr("data-link");
		
		$("#js-contact-form > div:nth-child(1) > div > .nvsSel > a").trigger("click");
		$('a:contains("'+selector+'")').click();
		// let element = $(this);
		$('html, body').animate({
			scrollTop: ($(".contact-form__wrapper").offset().top)
		}, 600);

	});
};

var timelineSwiper = {

	element: '.js-swiper--timeline',
	firstLoad: true,
	swiperTabs: undefined,
	map: [],
	tabs: [],

	init: function() {
		var self = this;

		if(self.swiperTabs == undefined){
			this.initSelector();
		}
	},

	destroy: function() {
		var self = this;

		if(self.swiperTabs !== undefined){
			self.swiperTabs.destroy(true, true);
		}
	},

	initSelector: function() {
		var self = this;

		self.swiperTabs = new Swiper('.js-swiper--timeline', {
			modules: [Navigation, Pagination, Scrollbar],
			loop: false,
			slidesPerView: "auto",
			spaceBetween: 24,

			navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
			on: {
				slideChange: function () {
					setTimeout(activeItem(this.activeIndex),300);
				},
				init: function () {
					activeItem(this.activeIndex);
				}
			},

			init: function(swiper) {

			},
		});


		handleNav();

		function activeItem(inde) {

		//	let activeItem = $(".js-swiper--timeline .swiper-slide-active");
		//	let slides = $(".timeline-block__swiper-wrapper .timeline-block__slide");

		//	let activeItemData = $(".js-swiper--timeline .swiper-slide-active").attr("data-id");
			let btns = $(".timeline-block__btn-wrap a");
			let btnOne = $(".timeline-block__btn-wrap a:nth-child(1)" );
			let btnTwo = $(".timeline-block__btn-wrap a:nth-child(2)" );
			let btnThree = $(".timeline-block__btn-wrap a:nth-child(3)" );
			

			if ($(window).width() <= 1365) {
				if(inde >= 0 && inde < 4) {
					btns.removeClass("active");
					btnOne.addClass("active");		
				} else if (inde >= 4 && inde < 10) {
					btns.removeClass("active");
					btnTwo.addClass("active");	
				} else if(inde >= 11){
					btns.removeClass("active");
					btnThree.addClass("active");		
				}
				
			} else if ($(window).width() >= 1366) {
				if(inde >= 0 && inde < 4) {
					btns.removeClass("active");
					btnOne.addClass("active");		
				} else if (inde >= 4 && inde < 9) {
					btns.removeClass("active");
					btnTwo.addClass("active");	
				} else if(inde >= 10){
					btns.removeClass("active");
					btnThree.addClass("active");		
				}
			}

			/*btns.each(function( index ) {
				let data = $(this).attr("data-target");

				
				$(this).removeClass("active");

				if(data == activeItemData) {
					$(this).addClass("active");
				
					//handleTitle();
				}
			});*/

			/*slides.each(function( index ) {

				let slideIndex = index; 

				let data = $(this).attr("data-id");

				if(slideIndex >4 ) {
					
				}
			});*/
		}

		function handleNav() {
			$(".timeline-block__btns").on('click', function(e) {
				e.preventDefault();

				$(".timeline-block__btns").removeClass("active");
				$(this).addClass("active");
				
				let btnIndex = $('.timeline-block__btns').index(this);//0 ,1,2
				console.log(btnIndex);

				/*if ($(window).width() <= 1365) {
					if(btnIndex  == 0) {
						let slideIndex = index;
						self.swiperTabs.slideTo(slideIndex, 600, false);
								
					} else if (btnIndex  == 1) {
						
					} else if(btnIndex  == 2){
							
					}
					
				} else if ($(window).width() >= 1366) {
					if(inde >= 0 && inde < 4) {
						btns.removeClass("active");
						btnOne.addClass("active");
								
					} else if (inde >= 4 && inde < 9) {
						btns.removeClass("active");
						btnTwo.addClass("active");	
					} else if(inde >= 10){
						btns.removeClass("active");
						btnThree.addClass("active");		
					}
				}*/

			

				//let dataBtn = $(this).attr("data-target");
				let slides = $(".timeline-block__swiper-wrapper .timeline-block__slide");
				let found = false;

				slides.each(function( index ) {
					//let data = $(this).attr("data-id");

					/*if(data == dataBtn && !found) {
						let slideIndex = index;
						self.swiperTabs.slideTo(slideIndex, 600, false);
						found = true;
					}*/

					//if ($(window).width() <= 1365) {
						if(btnIndex  == 0 && !found) {
							let slideIndex = 0;
							self.swiperTabs.slideTo(slideIndex, 600, false);
							found = true;
									
						} else if (btnIndex  == 1) {
							let slideIndex = 4;
							self.swiperTabs.slideTo(slideIndex, 600, false);
							found = true;
						} else if(btnIndex  == 2){
							let slideIndex = 11;
							self.swiperTabs.slideTo(slideIndex, 600, false);
							found = true;
						}
						
					//} 


				});
			})
		}

		/*function handleTitle() {

			let activeItemData = $(".js-swiper--timeline .swiper-slide-active").attr("data-id");

			console.log(activeItemData);
			//$('.timeline-block__side-title').text(activeItemData);
		}*/
	},
};

var useSwiper = {

	element: '.js-swiper--use',
	firstLoad: true,
	swiperTabs: undefined,
	map: [],
	tabs: [],

	init: function() {
		var self = this;

		if(self.swiperTabs == undefined){
			this.initSelector();
		}
	},

	destroy: function() {
		var self = this;

		if(self.swiperTabs !== undefined){
			self.swiperTabs.destroy(true, true);
		}
	},

	initSelector: function() {
		var self = this;

		self.swiperTabs = new Swiper('.js-swiper--use', {
			modules: [Navigation, Pagination, Scrollbar],
			loop: false,
			slidesPerView: 1,
			spaceBetween: 10,

			pagination: {
				el: ".swiper-pagination",
				type: 'bullets',
			},
			on: {
				slideChange: function () {
				//	activeItem();
				},
			},

			init: function(swiper) {

				this.slideTo(getSlideIndexByClass('current'));
			},
		});
	},
};


window.hiw_modal = {
	modal:{},
	init: function() {
		this.modal = $('.article-modal');
		this._openBinding()

		$('.x-hiw-close').on('click', this._close.bind(this));
	},
	cb:function(res){
		let data = JSON.parse(res);
		if(data.success){
			console.log(data)
			this._fillData(data);
		}else{
			console.log("error");
			this._openBinding();
		}
	},
	_openBinding:function(bind){
		if(bind===undefined || bind){
			console.log("bind");
			$('.x-hiw-modal').on('click', this._getA.bind(this));
		}else{
			console.log("unbind");
			$('.x-hiw-modal').unbind('click');
		}
	},
	_openModal:function(){
		$('body').addClass('modal-open');
		this.modal.addClass('is-visible');
		$('.article-modal').scrollTop(0);
	},
	_getA:function(e){
		e.preventDefault();

		let id = parseInt($(e.currentTarget).data('article-id'));
		if(id !== 0){
			console.log(this);
			this._openBinding(false);
			let data = {id:id};
			fwajax.phpExecute({url:'/xajax/hiw_modal',}, data);
		}
	},
	_close:function(e){
		$('body').removeClass('modal-open');
		this.modal.removeClass('is-visible');
		this._openBinding();
	},
	_fillData:function(data){
		if(typeof(data.article2) !=='undefined'){
			$('.x_article2').show();
			if(typeof(data.article2.section_name)!=='undefined'){
				$('.x_article2_section_name').show();
				$('.x_article2_section_name').html(data.article2.section_name);
			}else{
				$('.x_article2_section_name').hide()
			}
			if(typeof(data.article2.type)!=='undefined'){
				$('.x_article2_type').show();
				$('.x_article2_type').html(data.article2.type);
			}else{
				$('.x_article2_type').hide()
			}
			if(typeof(data.article2.headline)!=='undefined'){
				$('.x_article2_headline').show();
				$('.x_article2_headline').html(data.article2.headline);
			}else{
				$('.x_article2_headline').hide()
			}
			if(typeof(data.article2.abstract)!=='undefined'){
				$('.x_article2_abstract').show();
				$('.x_article2_abstract').html(data.article2.abstract);
			}else{
				$('.x_article2_abstract').hide()
			}
			if(typeof(data.article2.body)!=='undefined'){
				$('.x_article2_body').show();
				$('.x_article2_body').html(data.article2.body);
			}else{
				$('.x_article2_body').hide()
			}
			if(typeof(data.article2.picture)!=='undefined'){
				$('.x_article2_picture').show();
				$('.x_article2_picture > img').attr('src', data.article2.picture);
			}else{
				$('.x_article2_picture').hide();
			}
		}else{
			$('.x_article2').hide();
		}

		if(typeof(data.article.section_name)!=='undefined'){
			$('.x_article_section_name').show();
			$('.x_article_section_name').html(data.article.section_name);
		}else{
			$('.x_article_section_name').hide()
		}
		if(typeof(data.article.type)!=='undefined'){
			$('.x_article_type').show();
			$('.x_article_type').html(data.article.type);
		}else{
			$('.x_article_type').hide()
		}
		if(typeof(data.article.headline)!=='undefined'){
			$('.x_article_headline').show();
			$('.x_article_headline').html(data.article.headline);
		}else{
			$('.x_article_headline').hide()
		}
		if(typeof(data.article.abstract)!=='undefined'){
			$('.x_article_abstract').show();
			$('.x_article_abstract').html(data.article.abstract);
		}else{
			$('.x_article_abstract').hide()
		}
		if(typeof(data.article.body)!=='undefined'){
			$('.x_article_body').show();
			$('.x_article_body').html(data.article.body);
		}else{
			$('.x_article_body').hide()
		}

		if(typeof(data.article.picture)!=='undefined'){
			$('.x_article_picture').show();
			$('.x_article_picture > img').one('load',()=>{ this._openModal() });
			$('.x_article_picture > img').one('error',()=>{ $('.x_article_picture').hide(); this._openModal() });
			$('.x_article_picture > img').attr('src', data.article.picture);
		}else{
			$('.x_article_picture').hide();
			this._openModal();
		}
	}
};

// for Vue
window.$ = window.JQuery = JQuery;

var scrollElement = document.body;

scrollElement.addEventListener('wheel', headerScrollEvent);
scrollElement.addEventListener('scroll', headerScrollEvent);

function headerScrollEvent(e) {
	if(checkScrollDirection(e)){

		$("#js-head").addClass("is-pinned");
		$("#js-head").removeClass("is-not-pinned");
	} else {
		$("#js-head").addClass("is-not-pinned");
		$("#js-head").removeClass("is-pinned");
	}
}

function checkScrollDirection(e){
	if(e.wheelDelta){
		return e.wheelDelta > 0;
	}

	return event.deltaY < 0;
}

function fixedNav() {

	var header = $(".site-header");
	var headerOffset = $('.site-header').offset().top;

	$(window).scroll(function() {

		var scroll = $(window).scrollTop();

		if (scroll > 100 ) {
			header.addClass("sticky");
		}else if (scroll > 100 ) {

		} else if (scroll < 1) {
			header.removeClass("sticky");
		}
	});
}


var VuduGdprPlugin = {


	options: {
		'necessary': {
			cookieName: 'gdpr_level_1_necessary',
			pristine: true,
			disabled: true,
			checked: true,
			el: 'gdpr_settings_choice_necessary'
		},
		'analytical': {
			cookieName: 'gdpr_level_2_analytical',
			pristine: true,
			disabled: false,
			checked: false,
			el: 'gdpr_settings_choice_analytical'
		},
		'marketing': {
			cookieName: 'gdpr_level_3_marketing',
			pristine: true,
			disabled: false,
			checked: false,
			el: 'gdpr_settings_choice_marketing'
		}
	},

	init: function () {


		if ($('#gdpr_toolbar').length) {
			this.bindEvent();

			var pristine = true;
			for (var i in VuduGdprPlugin.options) {
				var usersSelection = VuduGdprPlugin.options[i];

				var cookieValue = VuduGdprPlugin.getCookie(usersSelection.cookieName);
				if (cookieValue == 1) {
					pristine = false;

					if (usersSelection.disabled === false) {
						VuduGdprPlugin.options[i].checked = true;

						$("#" + usersSelection.el).prop("checked", true);
					}
				}
				else if (cookieValue == 0) {
					pristine = false;

					if (usersSelection.disabled === false) {
						VuduGdprPlugin.options[i].checked = false;

						$("#" + usersSelection.el).prop("checked", false);
					}
				}

			}

			if (pristine == false) {
				$("#js-toogle-gdpr").addClass("show");
				VuduGdprPlugin.hideToolbar();
			}
            else
			{
				$("#gdpr_toolbar").removeClass("hide");
			}
		}


	},

	bindEvent: function () {

		$('#gdpr_toolbar .x_submit_necessary').on("click", function (e) {
			e.preventDefault();

			VuduGdprPlugin.consentCookie('necessary', true);
			$('#gdpr_settings_choice_necessary').prop("checked", true);
			VuduGdprPlugin.consentCookie('analytical', false);
			$('#gdpr_settings_choice_analytical').prop("checked", false);
			VuduGdprPlugin.consentCookie('marketing', false);
			$('#gdpr_settings_choice_marketing').prop("checked", false);

			$('#gdpr-overlay').hide();
			$("#gdpr_settings_popup").removeClass("show");
			$('.gdpr-msg').removeClass("show");
			$('#gdpr_toolbar').addClass("hide");
			$('#js-toogle-gdpr').addClass("show");
		});


		$('#gdpr_toolbar .x_submit_all').on("click", function (e) {
			e.preventDefault();

			VuduGdprPlugin.consentCookie('necessary', true);
			$('#gdpr_settings_choice_necessary').prop("checked", true);
			VuduGdprPlugin.consentCookie('analytical', true);
			$('#gdpr_settings_choice_analytical').prop("checked", true);
			VuduGdprPlugin.consentCookie('marketing', true);
			$('#gdpr_settings_choice_marketing').prop("checked", true);

			$('#gdpr-overlay').hide();
			$("#gdpr_settings_popup").removeClass("show");
			$('.gdpr-msg').removeClass("show");
			$('#gdpr_toolbar').addClass("hide");
			$('#js-toogle-gdpr').addClass("show");
		});

		$('#gdpr_toolbar a.x_open_setup').on("click", function (e) {
			e.preventDefault();

			$('#gdpr_toolbar .gdpr-prompt__ctrl').toggleClass('active');
			$(this).toggleClass('active');
			$('#gdpr_settings_popup').toggleClass('show');
			$('.gdpr-msg').toggleClass('show');
		});

		$('#js-toogle-gdpr').on("click", function (e) {
			e.preventDefault();

			$('#gdpr_toolbar .gdpr-prompt__ctrl').removeClass('active');
			VuduGdprPlugin.showToolbar();
		});

		$("#gdpr_toolbar .x_submit_selected").on("click", function (e) {
			e.preventDefault();

			$("#gdpr_toolbar input.gdpr_level").each(function (index, item) {
				var name = $(item).val();
				var checked = $(this).prop("checked");
				VuduGdprPlugin.consentCookie(name, checked);
			});

			$('#gdpr_toolbar .gdpr-prompt__ctrl').removeClass('active');
			$('#gdpr_toolbar a.x_open_setup').removeClass('active');

			$('#gdpr-overlay').hide();
			$("#gdpr_settings_popup").removeClass("show");
			$('.gdpr-msg').removeClass("show");
			$('#gdpr_toolbar').addClass("hide");
			$('#js-toogle-gdpr').addClass("show");
		});
	},

	showToolbar: function () {
		$("#gdpr-overlay").show();
		$("#gdpr_toolbar").removeClass('hide');
	},

	hideToolbar: function () {
		$("#gdpr-overlay").hide();
		$("#gdpr_toolbar").addClass('hide');
	},

	consentCookie: function (name, checked) {

		if (VuduGdprPlugin.options[name] !== undefined) {
			var value = checked ? 1 : 0;
			VuduGdprPlugin.setCookie(VuduGdprPlugin.options[name].cookieName, value, 365);
		}
	},

	consentAllCookie: function () {

		for (var i in VuduGdprPlugin.options) {
			var usersSelection = VuduGdprPlugin.options[i];
			VuduGdprPlugin.consentCookie(usersSelection.cookieName, true);
		}
	},

	setLevel: function (lvl) {

		if (typeof (cookieDomainName) != 'undefined' && cookieDomainName) {
			//$.cookie(VuduGdprPlugin.cookieName, lvl, { expires: 365, path: '/', domain: cookieDomainName });
			VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, lvl, 365, cookieDomainName);
		}
		else {
			//$.cookie(VuduGdprPlugin.cookieName, lvl, { expires: 365, path: '/' });
			VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, lvl, 365);
		}
	},

	setMaxLevel: function () {

		if (typeof (cookieDomainName) != 'undefined' && cookieDomainName) {
			//$.cookie(VuduGdprPlugin.cookieName, 4, { expires: 365, path: '/', domain: cookieDomainName });
			VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, 4, 365, cookieDomainName);
		}
		else {
			//$.cookie(VuduGdprPlugin.cookieName, 4, { expires: 365, path: '/' });
			VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, 4, 365);
		}
	},

	setCookie: function (cname, cvalue, exdays, domain) {
		var domain = (typeof (domain) != 'undefined' && domain) ? domain : '.';
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var cookieExpires = "expires=" + d.toUTCString();
		var cookieDomain = "domain=" + domain;
		//document.cookie = cname + "=" + cvalue + ";" + cookieExpires + ";" + cookieDomain + ";path=/";
		document.cookie = cname + "=" + cvalue + ";" + cookieExpires;
	},

	getCookie: function (cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return null;
	}

}


console.log('main.js included');
window.addEventListener('DOMContentLoaded', () => { console.log('DOMContentLoaded test'); })

$(document).ready(function() {
	console.log('App ready!');

	if(typeof(fwajax)!=='undefined' && typeof(lang_code)!=='undefined'){
		fwajax.langSegment=`/${lang_code}/`;
	}


	navMobile();
	fixedNav();
	$('.nvsSel').nivasSelect();
	contactForm.init();
	calculator();
	faqAccordion();
	contactWrap();

	timelineSwiper.init();
	useSwiper.destroy();

	hiw_modal.init();

	if ($(window).width() < 992) {
		aimyAccordion();
		useSwiper.init();
	}
	VuduGdprPlugin.init();
});
